import { useTranslation } from "react-i18next";
import React from "react";

import { Space, SpaceTools } from "@/models/spaces";

import { GoalsAndProjects } from "./GoalsAndProjects";
import { Discussions } from "./Discussions";
import { ResourceHub } from "./ResourceHub";
import { Tasks } from "./Tasks";
import { Kpis } from "./Kpis";
import { Templates } from "./Templates";

interface ToolsSectionPros {
  space: Space;
  tools: SpaceTools;
}

export function ToolsSection({ space, tools }: ToolsSectionPros) {
  const { t } = useTranslation();
  return (
    <div className="mt-6 py-6">
      <div className="flex justify-center items-start flex-wrap gap-4">
        <GoalsAndProjects
          title={t("Goals & Projects")}
          space={space}
          goals={tools.goals ?? []}
          projects={tools.projects ?? []}
        />

        {tools.discussionsEnabled &&
          (tools.messagesBoards ?? []).map((boards) => (
            <Discussions space={space} discussions={boards.messages ?? []} key={boards.id} />
          ))}

        {tools.resourceHubEnabled &&
          (tools.resourceHubs ?? []).map((hub) => <ResourceHub resourceHub={hub} key={hub.id} />)}

        {tools.tasksEnabled && <Tasks space={space} tasks={tools.tasks ?? []} />}

        {tools.kpisEnabled && <Kpis space={space} kpis={tools.kpis ?? []} />}

        {tools.templatesEnabled && <Templates space={space} templates={tools.templates ?? []} />}
      </div>
    </div>
  );
}
